import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import BookingForm from '../components/BookingForm';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <Hero />
      <About />
      <Services />
      <BookingForm />
      <Gallery />
      <Footer />
    </div>
  );
};

export default LandingPage;
